<template>
  <div :class="wrapperClass">
    <profile-header></profile-header>
    <div class="user-content">
      <div :class="dynamicClass" style="margin-bottom: 20px !important;">
        <div class="my-auto w-100 main-area">
          <div class="profile-detail">
            <div class="profile-detail-block">
              <!-- Content of the profile-detail block -->
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import ProfileHeader from "@/components/header.vue";

export default {
  name: 'UserWrapper',
  components: { ProfileHeader },
  props: {
    extraWidth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dynamicClass: this.getClassForScreenSize()
    };
  },
  computed: {
    wrapperClass() {
      return 'user-wrapper w-100';
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateClassForScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateClassForScreenSize);
  },
  methods: {
    updateClassForScreenSize() {
      this.dynamicClass = this.getClassForScreenSize(); // Update the dynamic class based on screen size
    },
    getClassForScreenSize() {
      if (this.extraWidth && window.innerWidth >= 768) {
        return 'mx-5';
      } else {
        return 'container';
      }
    }
  }
};
</script>